import React from 'react';
import { Box, Center, Heading, Text, useColorModeValue, useToast, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ArcButton } from '../../../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../../../common/components/SlidingAnimationPageBase';
import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../../../../common/constants';
import { DeleteAccountIcon, OutlineGradientIcon } from '../../../../../styles/custom-icons';
import { clearGoogleAnalyticsIdentifiers } from '../../../../../utils/common/tracking-privacy';
import { useDeleteAccountMutation } from '../../../accountApi';

export function DeleteAccountConfirm() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toast = useToast();
  const redIconColor = useColorModeValue('#FF3E24', '#FF5B44');
  const [deleteAccount, { isLoading: isDeleteLoading }] = useDeleteAccountMutation();

  async function handleDeleteAccount() {
    try {
      await deleteAccount({}).unwrap();
      clearGoogleAnalyticsIdentifiers();
      navigate(`/logout`);
    } catch (error) {
      toast({
        title: t('Account.error deleting account'),
        description: `${t('Common.please try again')} ${t('Common.if this persists contact support')}`,
        status: 'error',
        duration: 2000,
        isClosable: true,
      });
    }
  }

  return (
    <SlidingAnimationPageBase px={4} title={t('Account.delete account')} backURL={`../verify-details?direction=back`}>
      <Box display="flex" flexDirection="column" h={`calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`}>
        <Center pt={4} pb={2}>
          <Box position="relative" w="48vw" h="48vw">
            <OutlineGradientIcon w="100%" h="100%" color={redIconColor} data-testid="outline-icon" />
            <DeleteAccountIcon
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              w="87px"
              h="74px"
              color={redIconColor}
              data-testid="delete-data-icon"
            />
          </Box>
        </Center>

        <VStack align="stretch" spacing={2} mb={2}>
          <Heading fontSize={24} fontWeight={600} textAlign="center" data-testid="delete-my-account-title">
            {t('Account.delete se home account')}
          </Heading>
        </VStack>

        <VStack align="stretch" spacing={2}>
          <Text textAlign="center">{`${t('Account.once you tap delete')}, ${t('Account.to cancel delete')}`}</Text>
          <Text textAlign="center">{t('Account.if delete request is not cancelled')}</Text>
        </VStack>

        <Center mt="auto" mb={5} flexDir={'column'}>
          <ArcButton
            arcColor={redIconColor}
            w="100%"
            py={6}
            mt="auto"
            onClick={handleDeleteAccount}
            isLoading={isDeleteLoading}
            data-testid="delete-my-account-button"
          >
            {t('Account.delete my account')}
          </ArcButton>
        </Center>
      </Box>
    </SlidingAnimationPageBase>
  );
}
